import React from "react";
import TextField from "@mui/material/TextField";
import {isNullOrUndefinedOrEmpty} from "../../utils.js";


const TextInput = ({
    name, label, errors, formState, setFormState, setErrors=(errs) => {}, ...props}) => {
    const error = !!errors[name];
    const helperText = error ? errors[name] : "";
    const currentValue = (formState[name] !== undefined ? formState[name] : props[name]);
    if (props?.value === null || (!props?.value && currentValue === null)) {
        console.error("TextInput received a null value for", name, "with props:", props);
    }
    return (
        <TextField
            {...props}
            fullWidth={true}
            margin="dense"
            variant="filled"
            label={label}
            id={props.id ?? name}
            value={props.value || currentValue}
            onChange={(e) => {
                setFormState({...formState, [name]: e.target.value});
                setErrors({...errors, [name]: ""});
            }}
            error={error}
            helperText={helperText}
        />
    );
};


export default TextInput;
